module.exports = __webpack_public_path__ + "static/21gde-43de929331a8e8e31b24eb9f2023e4cf.gif";